import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import MediaImage from '../atoms/MediaImage';
import Button from '../atoms/Button';
import Img from '../atoms/Img';
import Empty from '../atoms/Empty';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import styles from '../../styles/components/organisms/Gallery.module.scss';

interface GalleryProps {
  data: { small: string; large: string }[];
  bg?: boolean;
  thumbs?: boolean;
  showEmpty?: string;
  float?: boolean;
  className?: string;
  onEmptyClick?: () => void;
  toggle?: (full: boolean) => void;
}

export default function Gallery(props: GalleryProps) {
  const {
    data,
    bg,
    thumbs,
    showEmpty,
    onEmptyClick,
    toggle,
    float,
    className,
  } = props;
  const [full, setFull] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [sizes, setSizes] = useState({});
  const classes = clsx(
    styles.gallery,
    { [styles.bg]: !full && (bg || showEmpty || data.length === 1) },
    { [styles.thumbs]: thumbs },
    { [styles.slide]: !float },
    { [styles.full]: full },
    className
  );

  const toggleFull = () => {
    if (!!toggle) {
      toggle(!full);
    }
    setFull(!full);
  };

  useEffect(() => {
    const currSizes = {
      superLargeDesktop: {
        breakpoint: {
          max: 6000,
          min: 1376,
        },
        items: full ? 1 : 3,
        slidesToSlide: full ? 1 : 3,
        //partialVisibilityGutter: 40,
      },
      desktop: {
        breakpoint: {
          max: 1376,
          min: 1024,
        },
        items: full ? 1 : 3,
        slidesToSlide: full ? 1 : 3,
        //partialVisibilityGutter: 0,
      },
      tablet: {
        breakpoint: {
          max: 1023,
          min: 768,
        },
        items: full ? 1 : 2,
        slidesToSlide: full ? 1 : 2,
        //partialVisibilityGutter: 0,
      },
      mobile: {
        breakpoint: {
          max: 767,
          min: 0,
        },
        items: 1,
        slidesToSlide: 1,
        //partialVisibilityGutter: 0,
      },
    };
    setRefresh(true);
    setSizes(currSizes);
    setTimeout(() => setRefresh(false), 400);
  }, [full]);

  const CustomDot = ({ onClick = () => {}, ...props }) => (
    <li className={props.active ? styles.active : ''}>
      <button onClick={() => onClick()} />
    </li>
  );

  return (
    <div className={classes}>
      {!showEmpty && (!thumbs || (thumbs && full)) && (
        <Button
          white
          medium
          icon={full ? 'close' : 'expand'}
          onClick={toggleFull}
        />
      )}
      {thumbs && !full && (
        <ul className={!float ? styles.slide : undefined}>
          {data.map((el: any, index: number) => {
            return (
              <li key={index} onClick={toggleFull}>
                {/* {<MediaImage  src={{l: el.small, m: el.small, s: el.small}}/>} 
                <Image
                  src={el.small}
                  alt={'img'}
                  layout='fill'
                  objectFit='cover'
                />*/}
                <Img
                  src={el.small}
                  className={el.hidden ? styles.hidden : ''}
                />
              </li>
            );
          })}
        </ul>
      )}

      {!refresh && (!thumbs || (thumbs && full)) && (
        <Carousel
          className={`carousel${full ? '-full' : ''}`}
          additionalTransfrom={0}
          arrows={false}
          autoPlay={false}
          // autoPlaySpeed={3000}
          shouldResetAutoplay={false}
          dotListClass={styles.dots}
          draggable
          // centerMode={true}
          // partialVisible
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          showDots={data.length > 1}
          sliderClass=""
          swipeable
          customDot={<CustomDot />}
          // beforeChange={() => setIsMoving(true)}
          // afterChange={() => setIsMoving(false)}
          responsive={sizes}
        >
          {data.map((el: any, index: number) => {
            const src = full ? el.large : el.small;
            return (
              <MediaImage
                key={index}
                contain={full}
                className={el.hidden ? styles.hidden : ''}
                src={{ l: src, m: src, s: src }}
              />
            );
          })}
          {!!showEmpty && <Empty onClick={onEmptyClick} label={showEmpty} />}
        </Carousel>
      )}
    </div>
  );
}
